// Angular
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';

// Services
import { AuthNoticeService } from '../../../core/auth';
import { ProductsService } from '../../../core/e-commerce/_services';


// Permissions
import { FrontendService } from '../../../service/frontend.service';
import { UIPermissionWrapper } from '../../../model/ui-permission-wrapper.model';

// Models 
import { Product, ProductCategory, ProductShape, productShapes } from '../../../core/e-commerce/_models/product';


@Component({
    selector: 'kt-dialog-product',
    templateUrl: './dialog-campaign-product.component.html',
    styleUrls: ['./dialog-campaign-product.component.scss']
})

export class DialogCampaignProductComponent implements OnInit {

    public permission: UIPermissionWrapper

    productDetailForm: FormGroup;
    error: boolean = false;
    categories: ProductCategory[];
    shapes: ProductShape[] = productShapes;
    filteredProducts: any;
    isLoading: boolean;
    replaceProducts = [];
    suggestedProducts = [];
    productAutocomplete: FormControl = new FormControl();
    productAutocompleteSuggested: FormControl = new FormControl();
    private selectedProductId: any;
    private selectedProductIdSuggested: any;
    selectedProduct;
    selectedProductSuggested;

    private viewInit: boolean = false;

    @ViewChild('reachInput') public reachInput: ElementRef;
    @ViewChild('reOrderQuantityInput') public reOrderQuantityInput: ElementRef;

    constructor(
        private _snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogCampaignProductComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
        private productsService: ProductsService,
        private frontendService: FrontendService
    ) {
    }

    ngOnInit() {
        // Permisos UI
        this.permission = this.frontendService
            .permissionFor("shared/dialog-campaign-product/dialog-campaign-product.component");

        this.authNoticeService.setNotice(null);
        this.initProductForm();
        this.loadCategories();
        this.productsAutocomplete();
    }

    ngAfterViewInit() {
        // Para evitar el bug de ViewChilden {static: true} que no se puede usar en Angular 7
        this.viewInit = true;
    }

    initProductForm() {
        this.productDetailForm = this.fb.group({
            // code: [{value: this.data.productData ? this.data.productData.code : null, disabled: false}, Validators.required],
            // name: [this.data.productData ? this.data.productData.name : '', Validators.required],
            // productCategoryId: [this.data.productData ? this.data.productData.productCategoryId : '', Validators.required],
            // width: [this.data.productData ? this.data.productData.width : ''],
            // length: [this.data.productData ? this.data.productData.length : ''],
            // height: [this.data.productData ? this.data.productData.height : ''],
            // volume: [this.data.productData ? this.data.productData.volume : '', Validators.required],
            // productShape: [this.data.productData ? this.data.productData.productShape : '', Validators.required],
            // active: [this.data.productData ? this.data.productData.active : false],
        });

        if (this.data.product && this.data.product.campaignProductReplacements) {
            this.replaceProducts = [...this.data.product.campaignProductReplacements];
        }
        if (this.data.product && this.data.product.campaignProductSuggested) {
            this.suggestedProducts = [...this.data.product.campaignProductSuggested];
        }
    }

    saveProduct() {
        // const controls = this.productDetailForm.controls;
        // if (this.productDetailForm.invalid) {
        //     Object.keys(controls).forEach(controlName => {
        //         controls[controlName].markAsTouched();
        //     }
        //     );
        //     return;
        // }

        try {
            let data = this.prepareJSON(this.productDetailForm.value);
            if (this.data.product == null) {
                this.productsService.createCampaignProduct(data).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                    error => {
                        this._snackBar.open('Hubo un error', 'OK', {
                            duration: 5000,
                        });
                    });
            } else {
                this.productsService.updateCampaignProduct(data).subscribe(resp => {
                    this.dialogRef.close(true);
                },
                    error => {
                        this._snackBar.open('Hubo un error al actualizar', 'OK', {
                            duration: 5000,
                        });
                    });
            }
        }
        catch (error) {
            console.log(error)
            this.error = true;
        }
    }

    prepareJSON(data) {
        // TODO: Armar esto en un form
        data = this.data.product;
        let replaceProducts = this.replaceProducts;
        let suggestedProducts = this.replaceProducts;
        for (let i = 0; i < replaceProducts.length; i++) {
            replaceProducts[i].priority = i + 1;
        }
        for (let i = 0; i < suggestedProducts.length; i++) {
            suggestedProducts[i].priority = i + 1;
        }
        data.campaignProductReplacements = this.replaceProducts;
        data.campaignProductSuggested = this.suggestedProducts;
        data.reachId = parseInt(this.reachInput.nativeElement.value);
        data.reorderQuantity = this.reOrderQuantityInput ? parseInt(this.reOrderQuantityInput.nativeElement.value) : data.reorderQuantity
        return data;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.productDetailForm.controls[controlName];
        if (!control) {
            return false;
        }

        const result = control.hasError(validationType) && (control.dirty || control.touched);
        return result;
    }

    private loadCategories() {
        this.productsService.getProductCategories().subscribe(resp => {
            this.categories = resp;
        },
            error => {
                console.log(error);
            });
    }

    productsAutocomplete() {
        this.productsAutocompleteGeneric(this.productAutocomplete);
        this.productsAutocompleteGeneric(this.productAutocompleteSuggested);
    }

    productsAutocompleteGeneric(control) {
        control
            .valueChanges
            .pipe(
                debounceTime(500),
                tap(() => this.isLoading = true),
                switchMap(value => {
                    if (!value) {
                        return of([]);
                    }
                    let filter = {
                        Code: value,
                        CampaignId: this.data.product.campaignId
                    };
                    let data = {
                        filter: filter,
                        pageNumber: 1,
                        pageSize: 20,
                        sortField: 'Id',
                        sortOrder: 'asc',
                    };
                    return this.productsService.findCampaignProducts(data);
                }
                )
            ).subscribe((result: any) => {
                this.isLoading = false;
                this.filteredProducts = result.items;
                this.cdr.detectChanges();
            });
    }

    productSelected($event) {
        if ($event.option.value) {
            let campaignProduct = $event.option.value;
            this.selectedProductId = campaignProduct.id;
            this.selectedProduct = campaignProduct.product;
            this.productAutocomplete.setValue(campaignProduct.product.code + ' - ' + campaignProduct.product.name);
        }
    }

    productSelectedSuggested($event) {
        if ($event.option.value) {
            let campaignProduct = $event.option.value;
            this.selectedProductIdSuggested = campaignProduct.id;
            this.selectedProductSuggested = campaignProduct.product;
            this.productAutocompleteSuggested.setValue(campaignProduct.product.code + ' - ' + campaignProduct.product.name);
        }
    }

    productCodeChange() {
        this.selectedProductId = null;
        this.selectedProduct = null;
        this.productAutocomplete.setValue(null);
        // this.replacePriority.setValue(null);
        this.selectedProductIdSuggested = null;
        this.selectedProductSuggested = null;
        this.productAutocompleteSuggested.setValue(null);
        // this.suggestedPriority.setValue(null);
    }

    addReplaceProduct() {
        if (!this.selectedProductId) {
            this.productAutocomplete.markAsTouched();
            this.productAutocomplete.setErrors({ 'required': true });
        }
        // if (!this.replacePriority.value) {
        //     this.replacePriority.markAsTouched();
        //     this.replacePriority.setErrors({'required': true});
        // }

        let find = this.replaceProducts.find(product => product.replacementId === this.selectedProductId);
        if (find) {
            return;
        }

        if (this.selectedProductId) {
            // TODO: Tipar variable (CampaignProductReplacement)
            let newProduct = {
                replacementId: this.selectedProductId,
                replacement: {
                    product: {
                        code: this.selectedProduct.code,
                        name: this.selectedProduct.name,
                    }
                }
                // priority: this.replacePriority.value,               
            };
            this.replaceProducts.push(newProduct);
            this.productCodeChange();
        }
    }

    addSuggestedProduct() {
        if (!this.selectedProductIdSuggested) {
            this.productAutocompleteSuggested.markAsTouched();
            this.productAutocompleteSuggested.setErrors({ 'required': true });
        }
        // if (!this.suggestedPriority.value) {
        //     this.suggestedPriority.markAsTouched();
        //     this.suggestedPriority.setErrors({'required': true});
        // }

        let find = this.suggestedProducts.find(product => product.suggestedId === this.selectedProductIdSuggested);
        if (find) {
            return;
        }

        if (this.selectedProductIdSuggested) {
            // TODO: Tipar variable (CampaignProductSuggested)
            let newProduct = {
                suggestedId: this.selectedProductIdSuggested,
                suggested: {
                    product: {
                        code: this.selectedProductSuggested.code,
                        name: this.selectedProductSuggested.name
                    }
                }
                // priority: this.suggestedPriority.value,
            };
            this.suggestedProducts.push(newProduct);
            this.productCodeChange();
        }
    }

    deleteReplaceProduct(selectedProduct: any) {
        this.replaceProducts = this.replaceProducts.filter(product => product.replacementId !== selectedProduct.replacementId);
    }

    deleteSuggestedProduct(selectedProduct: any) {
        this.suggestedProducts = this.suggestedProducts.filter(product => product.suggestedId !== selectedProduct.suggestedId);
    }

    public deleteReOrderMaxQuantity(): void {
        this.reOrderQuantityInput.nativeElement.value = undefined;
    }

    public canDeleteReOrderMaxQuantity() {
        return this.viewInit && this.reOrderQuantityInput.nativeElement.value
    }

    public dismissAlert(): void {
        this.error = false;
    }

}

export interface DialogData {
    product: Product;
}
